import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";
import { consumeReturnTo } from "./returnTo";

export function CallbackPage() {
    const auth = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!auth.isLoading && auth.isAuthenticated) {
            // Back to the page that sent the user to sign in (keeps ?fileId=).
            navigate(consumeReturnTo(auth.user?.state), { replace: true });
        }
        // auth.user is read fresh; re-running on a token renewal isn't wanted.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth.isLoading, auth.isAuthenticated, navigate]);

    if (auth.error) {
        return (
            <div className="flex min-h-screen items-center justify-center p-8">
                <div className="text-center">
                    <h1 className="text-lg font-semibold text-destructive">Sign-in failed</h1>
                    <p className="mt-2 text-sm text-muted-foreground">{auth.error.message}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="flex min-h-screen items-center justify-center">
            <p className="text-sm text-muted-foreground">Completing sign-in…</p>
        </div>
    );
}
